import ForbiddenPage from "@/components/ui/ForbiddenPage/ForbiddenPage";
import React from "react";

import { useGates } from "..";

import useShouldWait from "./useShouldWait";

export default function CanGuard({ gate, doNothingOnDisable, children, ...rest }) {
  const { can } = useGates(rest);
  const onDisableComponent = doNothingOnDisable ? <></> : <ForbiddenPage />;
  return useShouldWait() ? <></> : can(gate) ? children : onDisableComponent;
}
